import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {
	$("#search-btn").click(function(){
		var url = $("#s-query").data('url');

        var term = $("#s-query").val();
        if(term != ""){
            window.location = url + '?q=' + term;
        }

    });

	$("#msearch-btn").click(function(){
		var url = $("#ms-query").data('url');

        var term = $("#ms-query").val();
        if(term != ""){
            window.location = url + '?q=' + term;
        }

    });

    $(document).on('click', '.search-see-all-products-btn', function(e) {
        e.preventDefault();
        
        var term = $("#s-query").val().trim();

        if(term != ""){
            window.location = $(this).attr('href') + '?q=' + term;
            return;
        }

        window.location = $(this).attr('href');

        return;
    });

    
    var searchInput = $('#s-query');
    var deleteButton = $('#search-btn-delete');

    searchInput.on('keyup', function() {
        if (searchInput.val().trim().length > 2) {
            var values = 'q=' + searchInput.val().trim();
			$.ajax({
				type: "GET",
				url: searchInput.data('url'),
				data: values,
				success: function(response) {
                    if (response.status == 1) {

                        $('.search-see-all-products-btn').show();

                        var html = '<ul class="offcanvas-items results">';

                        for (var i in response.products) {
                            html += `<li class="d-flex align-items-center flex-md-column align-items-md-start mb-3 position-relative">
                                        <div class="offcanvas-items--image me-3 md-md-0">
                                            <img src="${response.products[i].main_image_url}" alt="${response.products[i].language.title}" class="img-fluid">
                                        </div>
                                        <h6>${response.products[i].language.title}</h6>
                                        <a href="${response.products[i].url}" title="${response.products[i].language.title}" class="stretched-link" style="width: auto;"></a>
                                    </li>`;
                        }

                        html += '</ul>';
                        
                        if (1*response.products.length < 1) {
                            html = `<p class="text-center">${response.message}</p>`;
                            $('.search-see-all-products-btn').hide();
                        }


                        $('.search-short-list-results').html(html);
                    }
				},
				error(error) {

				}
			});
        }
    });

    
    searchInput.on('input', function() {
        // Show or hide the delete button based on whether there is text in the input
        if (searchInput.val().trim() !== '') {
            deleteButton.addClass('active');
        } else {
            deleteButton.removeClass('active');
        }
    });

    // Add click event listener on the delete button to clear the input
    deleteButton.on('click', function() {
        searchInput.val('');
        deleteButton.removeClass('active');
    });

    $("#s-query").keypress(function(e){
        if(e.which == 13) {
			var url = $("#s-query").data('url');
            var term = $(this).val();
            if(term != ""){
                window.location = url + '?q=' + term;
            }
        }
    });

    $("#ms-query").keypress(function(e){
        if(e.which == 13) {
			var url = $("#ms-query").data('url');
            var term = $(this).val();
            if(term != ""){
                window.location = url + '?q=' + term;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search.js